import { baseApi } from "@/config";
import request from "./request";

export default (config) => {
  config.baseURL = baseApi.common;
  return request(config)
}

